import React from 'react';
import { RegisterOptions } from 'react-hook-form';
import { Heading, Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { GroupRestrictions } from 'src/common/OrderRestrictions/orderRestrictions.utils';
import { RestrictionType } from 'src/common/OrderRestrictions/RestrictionType/RestrictionType';

type RestrictionsListProps = {
  name: string;
  groupedRestrictions: GroupRestrictions;
  rules?: RegisterOptions;
};

export function RestrictionsList({
  name,
  groupedRestrictions,
  rules,
}: RestrictionsListProps): JSX.Element {
  return (
    <>
      {groupedRestrictions.map(({ categoryName, restrictions }) => (
        <Row key={categoryName}>
          {categoryName && (
            <Column phone={12}>
              <Stack y="x-sm">
                <Heading variant="h5">{categoryName}</Heading>
              </Stack>
            </Column>
          )}
          {restrictions.map(({ type, displayName, description }) => (
            <Column phone={6} key={type}>
              <RestrictionType
                key={type}
                name={`${name}.${type}`}
                text={displayName}
                value={type}
                description={description}
                rules={rules}
              />
            </Column>
          ))}
        </Row>
      ))}
    </>
  );
}
